import {
	ApplicationConfig,
	isDevMode,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { AppHash, TranslocoHttpLoader } from '@eventlyte/common';
import { GEOGRAPHICAL_DATA_SERVICE, GeographicalDataService } from '@eventlyte/forms';
import {
	COUNTRY_SERVICE,
	HttpCountryService,
	HttpRegistrationService,
	RecordStateService,
	REGISTRATION_SERVICE,
	REGISTRATION_STEP_SERVICE
} from '@eventlyte/registration';
import { provideTransloco, provideTranslocoInterceptor } from '@jsverse/transloco';
import { appHash } from './app.hash';
import { routes } from './app.routes';
import { TranslocoScopeProviders } from './app.transloco';
import { BgovTranslocoInterceptor } from './app.transloco-interceptor';
import { RegistrationStepService } from './shared/registration-steps';

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
		provideTransloco({
			config: {
				availableLangs: ['en', 'zh-CN', 'zh-HK'],
				defaultLang: 'zh-HK',
				reRenderOnLangChange: true,
				prodMode: !isDevMode(),
				missingHandler: {
					logMissingKey: false
				},
				flatten: {
					aot: true
				}
			},
			loader: TranslocoHttpLoader
		}),
		{ provide: AppHash, useValue: appHash },
		{ provide: REGISTRATION_STEP_SERVICE, useClass: RegistrationStepService },
		{ provide: RecordStateService, useClass: RecordStateService },
		{ provide: GEOGRAPHICAL_DATA_SERVICE, useClass: GeographicalDataService },
		{ provide: REGISTRATION_SERVICE, useClass: HttpRegistrationService },
		{ provide: COUNTRY_SERVICE, useClass: HttpCountryService },
		provideTranslocoInterceptor(BgovTranslocoInterceptor),
		TranslocoScopeProviders.Fields,
		TranslocoScopeProviders.Content,
		TranslocoScopeProviders.Validation,
		TranslocoScopeProviders.Registration,
		TranslocoScopeProviders.Forms
	]
};
